import { render, staticRenderFns } from "./KundenumsaetzeReiter.vue?vue&type=template&id=4dbff108&"
import script from "./KundenumsaetzeReiter.vue?vue&type=script&lang=js&"
export * from "./KundenumsaetzeReiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports